<template>
    <b-form-group
        id="input-group-5"
        :label="labelVal"
        label-for="label"
        class="upload-files"
    >
        <b-form-file
            id="profile-picture"
            ref="file"
            v-bind="$attrs"
            :placeholder="placeholderVal"
            drop-placeholder="Drop file here..."
            :accept="acceptFile"
            class="zindex"
            @change="uploadImage"
        ></b-form-file>
        <slot></slot>
    </b-form-group>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
const apiUrl = process.env.VUE_APP_API_URL
export default {
    /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
    props: {
        type: {
            type: String,
            required: true,
        },
        labelVal: {
            type: String,
        },
        placeholderVal: {
            type: String,
            default: 'Choose file to upload',
        },
        acceptFile: {
            type: String,
            default:
                'image/jpeg, image/png, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        },
        uploadFileCss: {
            type: Boolean,
            default: null,
        },
        importFileRun: {
            type: Boolean,
            default: false,
        },
        importCustomFile: {
            type: Boolean,
            default: false,
        },
        size: {
            type: Number,
            default: 10,
        },
    }, // End of Component > props

    /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
    data() {
        return {
            uploadPercentage: 0,
        }
    }, // End of Component > data

    /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
    computed: {
        ...mapGetters(['user', 'dataSegmentId', 'formBuilderList', 'loading']),
    }, // End of Component > mounted
    watch: {
        imagePreviewURL(value) {
            this.previewImage = value
        },
    }, // End of Component > methods

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    mounted() {
        this.$refs.file.reset()
    }, // End of Component > computed

    /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
    methods: {
        //Upload image
        async uploadImage(e) {
            // console.log('base upload file')
            let self = this
            this.$store.commit('setFileLoading', true)

            const file = e.target.files[0]
            try {
                let formData = new FormData()
                if (file) {
                    const originalName = file.name
                    /*
                        Add the form data we need to submit
                    */

                    formData.append('type', this.type)
                    formData.append('file', file)

                    if (this.formatBytes(file.size)) {
                        this.$toasted.show(
                            `File size must be less than ${this.size} MB`,
                            {
                                duration: 3000,
                                type: ['error'],
                            }
                        )
                        return false
                    }

                    let response = await axios.post(
                        apiUrl + 'files/',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                Authorization: `Bearer ${localStorage.getItem(
                                    'vueauth_token'
                                )}`,
                            },

                            onUploadProgress: function (progressEvent) {
                                this.uploadPercentage = parseInt(
                                    Math.round(
                                        (progressEvent.loaded /
                                            progressEvent.total) *
                                            100
                                    )
                                )
                                if (
                                    this.uploadPercentage < 98 &&
                                    this.importFileRun
                                ) {
                                    self.$emit(
                                        'show-progress',
                                        this.uploadPercentage
                                    )
                                }
                            },
                        }
                    )
                    response.data.data.originalName = originalName
                    this.$emit('set-value', response.data.data)
                    if (
                        this.importFileRun &&
                        this.type !== 'deltaListUploading'
                    ) {
                        let filename = response.data.data.fileName
                        let obj = {}
                        obj.fileName = filename
                        obj.dataSegmentId = this.dataSegmentId
                        await axios.post(
                            apiUrl + 'screening-data/import/',
                            obj,
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${localStorage.getItem(
                                        'vueauth_token'
                                    )}`,
                                },
                            }
                        )
                        this.$emit('show-progress', 100)
                    }
                    if (
                        this.importCustomFile &&
                        this.type !== 'deltaListUploading'
                    ) {
                        this.handleCustomFile(response)
                    }
                    if (this.type == 'deltaListUploading') {
                        let filename = response.data.data.fileName
                        let obj = {}
                        obj.fileName = filename
                        obj.dataSegmentId = this.dataSegmentId
                        await axios.post(
                            apiUrl + 'screening-data/importDelta/',
                            obj,
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${localStorage.getItem(
                                        'vueauth_token'
                                    )}`,
                                },
                            }
                        )
                    }
                    this.$emit('show-progress', 100)
                    this.$toasted.show(response.data.message, {
                        duration: 2000,
                        type: ['success'],
                    })
                }
            } catch (error) {
                console.log(error)
                //this.$store.commit('setError', error.response.data.message)
            }
            this.$store.commit('setFileLoading', false)
        }, // End of upload image function

        async handleCustomFile(response) {
            let filename = response.data.data.fileName
            let obj = {}
            obj.fileName = filename
            obj.dataSegmentId = this.dataSegmentId
            let result = await axios.post(
                apiUrl + 'screening-data/merge/',
                obj,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem(
                            'vueauth_token'
                        )}`,
                    },
                }
            )
            console.log(result)
            if (result.status == 201) {
                this.$toasted.show(result.data.message, {
                    duration: 3000,
                    type: ['error'],
                })
            } else {
                this.$emit('show-progress', 100)
                // this.$emit('set-file', result.data.data)
            }
        },

        formatBytes(bytes) {
            return (
                (bytes / 1048576).toFixed(3) >
                (typeof this.size != 'undefined' ? this.size : 20)
            )
        }, // End of formatBytes function
    },
} // End of export default
</script>
